// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1KqQF","location":"Header_location__1C2x3"};